module.exports = __webpack_public_path__ + "img/P.147f35a.svg";